angular
    .module("app")
    .controller("dettaglioCruscottoRichiestaClientiCtrl", function ($scope, $transactionFactory) {
        $scope.richiestePostVenditaModel = $transactionFactory.get();
        $scope.portal = "ARU";
    });